import { jsx as _jsx } from "react/jsx-runtime";
import { _className } from '@nu-art/thunderstorm-frontend/index';
export const QScrollWrapper = (props) => {
    const { className, flex, ..._props } = props;
    const wrapperClass = _className('q-scroll-wrapper', flex ? 'flex' : undefined, className);
    return _jsx("div", { className: wrapperClass, ..._props, children: props.children });
};
//# sourceMappingURL=QScrollWrapper.js.map